const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const AppContext = {
  baseApiUrl: isLocalhost
    ? "http://localhost:9090"
    : "https://fundacioncolegiosantotomas.com.ar",
  /*Familias */
  urlServiceLogin: "/cst-servicios/usuarios/login",
  urlServiceCta: "/cst-servicios/ctacte/consulta",
  urlServiceFactura: "cst-servicios/ctacte/consultafactura",
  urlServiceAlumno: "/cst-servicios/alumnos/consulta/",
  urlServiceChangePassword: "/cst-servicios/usuarios/change-password",
  /*Emppleados */
  urlServiceEmpleadoPorCuit: "/cst-servicios/empleados/por-cuit/",
  urlServiceLoginEmpleados: "/cst-servicios/empleados/loginEmpleados",
};

export default AppContext;
